import { Link } from 'react-router-dom';
import '../styles/NotFoundPage.css';

function NotFoundPage() {
    return (
        <div className="notfound-wrapper">
            <div className="notfound-content">
                <div className="notfound-code">404</div>
                <div className="notfound-divider" />
                <h1 className="notfound-title">Page Not Found</h1>
                <p className="notfound-desc">
                    The page you are looking for doesn't exist or has been moved.
                </p>
                <Link to="/" className="notfound-btn">
                    ← Back to Home
                </Link>
            </div>
            <div className="notfound-bg-circles">
                <span /><span /><span />
            </div>
        </div>
    );
}

export default NotFoundPage;
